import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'nameSearch',
    standalone: false
})
export class NameSearchPipe implements PipeTransform {
    transform(objects: any[], query: string): typeof objects {
        return query ? objects.filter(object => object.name.toLocaleLowerCase().indexOf(query) !== -1) : objects;
    }
}
